var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from 'react';
import { useGetLevelByIdQuery } from '../../../generated/graphql';
export var defaultUseGetLocationLevelReturn = {
    locationId: null,
    levelId: null,
    setLocationId: function () { },
    setLevelId: function () { },
    loading: false,
};
/**
 * Manages location + level selection and loads location details (including levels) for the active location.
 * If only `defaultLevelId` is provided, loads the level’s parent location via GraphQL.
 */
export function useGetLocationLevel(defaultLevelId) {
    if (defaultLevelId === void 0) { defaultLevelId = null; }
    var _a = __read(useState(null), 2), locationId = _a[0], setLocationId = _a[1];
    var _b = __read(useState(defaultLevelId), 2), levelId = _b[0], setLevelId = _b[1];
    var _c = useGetLevelByIdQuery({
        variables: { levelId: defaultLevelId || '' },
        skip: !defaultLevelId || !!locationId,
    }), levelData = _c.data, loading = _c.loading;
    /* In edit mode defaultLevelId comes late, so we need to set it here */
    useEffect(function () {
        if (levelId)
            return;
        setLevelId(defaultLevelId);
    }, [defaultLevelId, levelId]);
    useEffect(function () {
        var _a, _b, _c;
        if (locationId)
            return;
        var resolved = (_c = (_b = (_a = levelData === null || levelData === void 0 ? void 0 : levelData.getLevelById) === null || _a === void 0 ? void 0 : _a.levelLocation) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : null;
        if (resolved) {
            setLocationId(resolved);
        }
    }, [locationId, levelData]);
    return {
        locationId: locationId,
        levelId: levelId,
        setLocationId: setLocationId,
        setLevelId: setLevelId,
        loading: loading,
    };
}
